import { useCallback, useMemo, useState } from "react";

export function useLocalStorage<T>(
	keyName: string,
	defaultValue: T,
): [T, (value: T) => void] {
	const [storedValue, setStoredValue] = useState(() => {
		const value = window.localStorage.getItem(keyName);
		if (value) {
			return JSON.parse(value);
		} else {
			window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
			return defaultValue;
		}
	});
	const setValue = useCallback(
		(newValue: T) => {
			window.localStorage.setItem(keyName, JSON.stringify(newValue));
			setStoredValue(newValue);
		},
		[keyName],
	);
	return useMemo(() => [storedValue, setValue], [storedValue, setValue]);
}
